import { Button, TooltipDialog, PowerWordFilledSVG } from "@newsela/angelou";
import PropTypes from "prop-types";

import {
  withTrackEvent,
  objectTypes,
  actionPrefixes,
  actionNames,
} from "@newsela/snitch";
import { tooltipDialogOffset } from "@/view/constants/styles/accessibleFontSizeMapping/accessibleFontSizeMapping.style";
import useCurrentArticleLevelId from "@/view/utils/useCurrentArticleLevelId";
import PowerWordPopoutBody from "../PowerWordPopoutBody";
import {
  containerCss,
  closeIconCss,
  tooltipArrowCss,
} from "../PowerWordPopoutBody/PowerWordPopoutBody.style";
import {
  rootCss,
  buttonCss,
  powerWordBoltIconCss,
} from "./PowerWordButton.style";

const propTypes = {
  currentFontSize: PropTypes.string,
  dataIdentifier: PropTypes.string,
  isLiteNonStudent: PropTypes.bool.isRequired,
  powerWord: PropTypes.string,
  powerWordId: PropTypes.string,
  wordDefinition: PropTypes.string,
  children: PropTypes.node,
};

const TooltipDialogWithTrackEvent = withTrackEvent(TooltipDialog);

const PowerWordButton = ({
  currentFontSize,
  dataIdentifier,
  isLiteNonStudent,
  powerWord,
  powerWordId,
  wordDefinition,
  children,
}) => {
  const levelId = useCurrentArticleLevelId();

  const eventProperties = {
    objectType: objectTypes.articleWord,
    actionPrefix: actionPrefixes.initiate,
    actionName: actionNames.read,
    streamProperties: {
      content_type: "Article",
      description: "Open power word popout",
      content_id: levelId,
      object_id: powerWordId,
    },
  };

  const getTooltipDialogOffset = (currentFontSize) => {
    return tooltipDialogOffset[currentFontSize];
  };

  return (
    // We need this wrapper div to add `data-identifier`, which is not yet supported by Angelou
    <div css={rootCss} data-identifier={dataIdentifier}>
      <TooltipDialogWithTrackEvent
        __cssFor={{
          Button: {
            root: buttonCss(currentFontSize),
            Icon: {
              root: powerWordBoltIconCss(currentFontSize),
            },
          },
          dialog: {
            root: containerCss,
            Button: { Icon: { root: closeIconCss(currentFontSize) } },
            arrow: tooltipArrowCss,
          },
        }}
        dialogAriaProps={{ "aria-label": powerWord }}
        buttonContents={<span>{children}</span>}
        buttonProps={{
          ariaProps: { "aria-label": `${powerWord}, power word` },
          flavor: Button.flavors.incognito,
          icon: {
            SvgComponent: PowerWordFilledSVG,
          },
        }}
        body={
          <PowerWordPopoutBody
            currentFontSize={currentFontSize}
            contentId={levelId}
            isLiteNonStudent={isLiteNonStudent}
            powerWord={powerWord}
            powerWordId={powerWordId}
            wordDefinition={wordDefinition}
          />
        }
        dataProps={{
          "data-qa-selector": "power_word_article_popout_button",
        }}
        offset={getTooltipDialogOffset(currentFontSize)}
        {...eventProperties}
      />
    </div>
  );
};

PowerWordButton.propTypes = propTypes;

export default PowerWordButton;
